import ITrackingService from "../../spi/ITrackingService";
import ITrackingEvent, { ITrackingEventCategory, ITrackingEventName, IEventGeo, ITrackingEventActor, IEventDeviceInfo } from "../../../types/ITrackingEvent";
import FirebaseService from "./FirebaseService";
import {isBrowser,  isMobile,  isTablet,  isSmartTV,  isConsole,  isWearable,  isMobileSafari,  
    isChromium,  isMobileOnly,  isAndroid,  isWinPhone,  isIOS,  isChrome,  isFirefox,  isSafari,  
    isOpera,  isIE,  isEdge,  isYandex,  osVersion,  osName,  fullBrowserVersion,  browserVersion,  
    browserName,  mobileVendor,  mobileModel,  engineName,  engineVersion,  getUA,  deviceType} from 'mobile-device-detect'
import IUser from "../../../types/IUser";


export default class FirebaseTrackingService implements ITrackingService{

    track(eventCategory: ITrackingEventCategory, eventName: ITrackingEventName, attributes: any): void {
        const trackingEvent:ITrackingEvent = {
            eventCategory: eventCategory,
            eventName: eventName,
            attributes: attributes,
            deviceInfo: this._getDeviceInfo(),
            geoInfo: this._getGeoInfo(),
            actor: this._getLoggedInUser(),
            timestamp: new Date(),
            correlationId: '-----' 
        }
        try{
            FirebaseService.getInstance().sendTrackingEvent(trackingEvent);
        }catch(e){
            debugger;
            throw e;
        }
        
    }


    private _getDeviceInfo():IEventDeviceInfo{
        return {
            isBrowser : isBrowser || false,
            isMobile : isMobile || false,
            isTablet : isTablet || false,
            isSmartTV : isSmartTV || false,
            isConsole : isConsole || false,
            isWearable : isWearable || false,
            isMobileSafari : isMobileSafari || false,
            isChromium : isChromium || false,
            isMobileOnly : isMobileOnly || false,
            isAndroid : isAndroid || false,
            isWinPhone : isWinPhone || false,
            isIOS : isIOS || false,
            isChrome : isChrome || false,
            isFirefox : isFirefox || false,
            isSafari : isSafari || false,
            isOpera : isOpera || false,
            isIE : isIE || false,
            isEdge : isEdge || false,
            isYandex : isYandex || false,
            osVersion : osVersion || '',
            osName : osName || '',
            fullBrowserVersion : fullBrowserVersion || '',
            browserVersion : browserVersion || '',
            browserName : browserName || '',
            mobileVendor : mobileVendor || '',
            mobileModel : mobileModel || '',
            engineName : engineName || '',
            engineVersion : engineVersion || '',
            getUA : getUA || '',
            deviceType : deviceType || '',
            screenWidth: screen.width || -1,
            screenHeight: screen.height || -1,
        }
    }

    private _getGeoInfo():IEventGeo {
        //TODO:
        return {
            lat: '99.0098878',
            lng: '-89.00988788'
        }
    }

    private _getLoggedInUser():ITrackingEventActor{
        const u: any = FirebaseService.getInstance().getCurrentUser();
        return {
            uid: u.uid || '',
            name: u.username || '',
            type: u.roles && u.roles.length > 0 ? u.roles[0].name : 'NA'
        }
    }
    
}